module.exports = __webpack_public_path__ + "static/img/index_10_01.4a79076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_10_01.jpg
// module id = T7+Z
// module chunks = 3